import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function initScrollSequence() {

    const frameCount = 300;

    const canvas = document.getElementById("sequence");
    const context = canvas.getContext("2d");

    const leftBlock = document.querySelector(".slides__inner");
    const navItems = document.querySelectorAll(".nav-item");
    const slideItems = document.querySelectorAll(".slide__item");

    const totalSlides = slideItems.length;

    const slidesMap = [
        { start: 0, end: 49 },
        { start: 50, end: 99 },
        { start: 100, end: 149 },
        { start: 150, end: 199 },
        { start: 200, end: 249 },
        { start: 250, end: 299 },
    ];

    const dpr = window.devicePixelRatio || 1;

    function resizeCanvas() {
        const rect = canvas.getBoundingClientRect();
        canvas.width = rect.width * dpr;
        canvas.height = rect.height * dpr;
        context.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    resizeCanvas();
    window.addEventListener("resize", resizeCanvas);

    // preload
    const images = [];
    const getSrc = (i) =>
        `/images/scroll-slider/${String(i).padStart(5,'0')}.webp`;

    for (let i = 0; i < frameCount; i++) {
        const img = new Image();
        img.src = getSrc(i);
        images.push(img);
    }

    let lastFrame = -1;

    function render(frame) {
        if (!images[frame] || frame === lastFrame) return;
        lastFrame = frame;

        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(
            images[frame],
            0,
            0,
            canvas.width / dpr,
            canvas.height / dpr
        );
    }

    function updateNav(frame) {
        const stageIndex = slidesMap.findIndex(
            s => frame >= s.start && frame <= s.end
        );

        navItems.forEach((el, i) => {
            el.classList.toggle("active", i === stageIndex);
        });
    }

    const obj = { progress: 0 };

    images[0].onload = () => {

        render(0);

        gsap.to(obj, {
            progress: 1,
            ease: "none",
            scrollTrigger: {
                trigger: ".scroll__slider",
                start: "top top",
                end: `+=${window.innerHeight * totalSlides}`,
                scrub: true,
                pin: true,
            },
            onUpdate: () => {

                const progress = obj.progress;

                // Canvas
                const frame = Math.round(progress * (frameCount - 1));
                render(frame);

                updateNav(frame);
                updateText(frame);

                // Текст
                // const maxOffset = window.innerHeight * (totalSlides - 1);
                // const y = -progress * maxOffset;
                // gsap.set(leftBlock, { y });

                // Nav
                // updateNav(frame);
            }
        });
    };

    function updateText(frame) {
        const stageIndex = slidesMap.findIndex(
            s => frame >= s.start && frame <= s.end
        );

        const y = -stageIndex * window.innerHeight;

        gsap.set(leftBlock, { y });
    }
}
